
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class TrustPilotRating extends Vue{
@Prop({default: false, type: Boolean}) mini!: boolean
};
